module.exports = __webpack_public_path__ + "static/media/ivars-krutainis-MuRMTbd8s3Y-unsplash (1).1314d75c.jpg";